import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../Store/actions';

import Cluster from '../Support/Cluster';
import dollarfy from '../Support/Dollarfy';

import imgXpediteLogo from '../images/xpedite-logo.png';
import imgHelpGraphicTable from '../images/help-graphic-table.png';
import imgHelpGraphicSlider from '../images/help-graphic-slider.png';

const modal = (props) => {

	if(props.modal === null) return null;

	if(props.modal === 'loadal') {

		return (
			<Cluster>
				<div className='modal__backdrop'></div>
				<div className='modal'>
					<div className='loader__content'>
						<i className='fas fa-calculator'></i>
						<p>Loading</p>
					</div>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'delete_matter') {

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<h4 className='modal__confirmation'>Are you sure you want to delete this matter?</h4>
					<p className='modal__line'>This can not be undone.</p>
					<p className='modal__line'><button className='btn' onClick={() => props.rdxDeleteMatter(props.token,props.matter.id,props.matter.code,props.history)}>Delete Matter</button> <button className='btn btn--grey' onClick={() => props.rdxSetModal(null)}>Cancel</button></p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'accept_offer') {

		const last_offer = +props.offers_primary.length - 1;

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<h4 className='modal__confirmation modal__confirmation--redline'>Has the offer of ${dollarfy(props.offers_primary[last_offer].value)} been accepted?</h4>
					<p className='modal__line'><button className='btn btn--grey' onClick={
						() => props.rdxSetModal(null)}>Cancel</button> &nbsp; <button className='btn' onClick={
						() => props.rdxAcceptOffer('primary',last_offer)}>Accept</button></p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'accept_counter') {

		const last_offer = +props.offers_counter.length - 1;

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<h4 className='modal__confirmation modal__confirmation--redline'>Has the counter offer of ${dollarfy(props.offers_counter[last_offer].value)} been accepted?</h4>
					<p className='modal__line'><button className='btn btn--grey' onClick={
						() => props.rdxSetModal(null)}>Cancel</button> &nbsp; <button className='btn' onClick={
						() => props.rdxAcceptOffer('counter',last_offer)}>Accept</button></p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'decline_offer') {

		const last_offer = +props.offers_primary.length - 1;

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<h4 className='modal__confirmation modal__confirmation--redline'>Revert offer decision?</h4>
					<p className='modal__line'><button className='btn btn--grey' onClick={
						() => props.rdxSetModal(null)}>Cancel</button> &nbsp; <button className='btn' onClick={
						() => props.rdxDeclineOffer('primary',last_offer)}>Revert</button></p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'decline_counter') {

		const last_offer = +props.offers_counter.length - 1;

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<h4 className='modal__confirmation modal__confirmation--redline'>Revert counter offer decision?</h4>
					<p className='modal__line'><button className='btn btn--grey' onClick={
						() => props.rdxSetModal(null)}>Cancel</button> &nbsp; <button className='btn' onClick={
						() => props.rdxDeclineOffer('counter',last_offer)}>Revert</button></p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'info') {

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<h4 className='modal__logo'><img src={imgXpediteLogo} alt='Xpedite' /></h4>
					<p className='modal__line modal__line--brown'>&copy; Copyright { new Date().getFullYear() } Hall Chadwick Melbourne Pty Ltd A.B.N. 88 081 186 450. All rights reserved.<br />Liability limited by a scheme approved under Professional Standards Legislation.</p>
					<p className='modal__line modal__line--brown'><strong>Hall Chadwick Forensics Level 14 440 Collins Street Melbourne Australia</strong></p>
					<ul className='modal__list'>
						<li className='modal__list__item modal__list__item--brown'><svg className='fas fa-phone' /> <a href='tel:61398206400' rel='noopener noreferrer'>+61 3 9820 6400</a></li>
						<li className='modal__list__item modal__list__item--brown'><svg className='fas fa-globe' /> <a href='http://www.hallchadwickmelb.com.au' target='_blank' rel='noopener noreferrer'>www.hallchadwickmelb.com.au</a></li>
						<li className='modal__list__item modal__list__item--brown'><svg className='fas fa-at' /> <a href='mailto:forensics@hallchadwickmelb.com.au' rel='noopener noreferrer'>forensics@hallchadwickmelb.com.au</a></li>
					</ul>
					<p className='modal__line'><button className='btn btn--grey' onClick={() => props.rdxSetModal(null)}>Close</button></p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'help_plaintiff_claim') {

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal modal--wide'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<div className='modal__left'>
						<h4 className='modal__headline'>Plaintiff - Claim</h4>
						<p className='modal__line modal__line--help'>This section provides for detailing the client's claim.</p>
						<p className='modal__line modal__line--help'>You can remove, hide or add more items. A pop up will appear when you select to remove a claim item just to confirm your intention to entirely delete the item from the claim.</p>
						<p className='modal__line modal__line--help'>Enter the category of claim in the placeholder ‘Description’ then a figure in dollars in the placeholder 'Amount ($)'.</p>
					</div>
					<div className='modal__right'>
						<img src={imgHelpGraphicTable} alt='Table explanation graphic' />
					</div>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'help_plaintiff_costs') {

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<h4 className='modal__headline'>Plaintiff – Legal Costs & Disbursement</h4>
					<p className='modal__line modal__line--help'>This section allows for the costs of the matter incurred by the plaintiff.</p>
					<p className='modal__line modal__line--help'>Enter either the actual or estimated 'Cost to date' in the placeholder 'Amount'.</p>
					<p className='modal__line modal__line--help'>Enter the estimated 'Cost to complete' for the final hearing in the placeholder 'Amount'.</p>
					<p className='modal__line modal__line--help'>These amounts can be adjusted at any time.</p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'help_interest_claim') {

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<h4 className='modal__headline'>Interest Claim Estimate</h4>
					<p className='modal__line modal__line--help'>This section estimates the interest claim if the matter proceeds to court for a final hearing and judgement.</p>
					<p className='modal__line modal__line--help'>Estimate the interest claim if the matter proceeds to a final hearing and judgement.</p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'help_winloss_probability') {

		let mcontent = (
			<div className='modal__left'>
				<h4 className='modal__headline'>Win/Loss Probability</h4>
				<p className='modal__line modal__line--help'>The Win/Loss Probability reflects the plaintiff's risk if the matter proceeds to final hearing and judgement.</p>
				<p className='modal__line modal__line--help'>The underlying assumption is a greater than 50% probability of the plaintiff succeeding at trial.</p>
			</div>
		);

		if(props.matter.angle === 'defendant') {
			mcontent = (
				<div className='modal__left'>
					<h4 className='modal__headline'>Win/Loss Probability</h4>
					<p className='modal__line modal__line--help'>The Win/Loss Probability reflects the defendant's risk if the matter proceeds to final hearing and judgement.</p>
				</div>
			);
		}

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal modal--wide'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					{mcontent}
					<div className='modal__right'>
						<img src={imgHelpGraphicSlider} alt='Slider explanation graphic' />
					</div>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'help_defendant_costs') {

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<h4 className='modal__headline'>Defendant – Legal Cost</h4>
					<p className='modal__line modal__line--help'>This section allows for the costs of the matter incurred by the defendant.</p>
					<p className='modal__line modal__line--help'>Either the actual or estimated 'Cost to date' in the placeholder 'Amount'.</p>
					<p className='modal__line modal__line--help'>Enter the estimated 'Cost to complete' in the placeholder 'Amount'.</p>
					<p className='modal__line modal__line--help'>These amounts can be adjusted at any time.</p>
					<p className='modal__line modal__line--help'>Tip: You can base this estimate on the estimated cost to date and estimated cost to complete using the {props.matter.angle}'s legal costs.</p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'help_legal_costs') {

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<h4 className='modal__headline'>Taxed Legal Costs</h4>
					<p className='modal__line modal__line--help'>This part allows for a percentage estimate for the likely legal costs to be awarded and recovered if the matter proceeds to final trial and judgement.</p>
					<p className='modal__line modal__line--help'>Enter the estimate in the placeholder 'Percentage'.</p>
					<p className='modal__line modal__line--help'>At this point you can calculate the Plaintiff’s position on the possible outcomes of their claim.</p>
					<p className='modal__line modal__line--help'>And, you can enter a Counter Claim from the defendant.</p>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'help_counter_claim') {

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal modal--wide'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<div className='modal__left'>
						<h4 className='modal__headline'>Counter Claim</h4>
						<p className='modal__line modal__line--help'>This section provides for detailing the counter claim.</p>
						<p className='modal__line modal__line--help'>You can remove, hide or add more counter claims.</p>
						<p className='modal__line modal__line--help'>Enter the category of claim in the placeholder 'Description' then a figure in dollars in the placeholder 'Amount ($)'.</p>
					</div>
					<div className='modal__right'>
						<img src={imgHelpGraphicTable} alt='Table explanation graphic' />
					</div>
				</div>
			</Cluster>
		);

	}
	else if(props.modal === 'help_counter_probability') {

		return (
			<Cluster>
				<div className='modal__backdrop' onClick={() => props.rdxSetModal(null)}></div>
				<div className='modal modal--wide'>
					<div className='modal__x' onClick={() => props.rdxSetModal(null)}>x</div>
					<div className='modal__left'>
						<h4 className='modal__headline'>Counter Claim Win/Loss Probability</h4>
						<p className='modal__line modal__line--help'>This part allows you to estimate the probability of a win or loss at trial for the defendant. The inverse of that probability will automatically be calculated for the plaintiff.</p>
						<p className='modal__line modal__line--help'>Move the slide to reach your estimated win/loss probability percentage.</p>
						<p className='modal__line modal__line--help'>At this point you can calculate the Plaintiff’s position on the possible outcomes of their counter claim.</p>
					</div>
					<div className='modal__right'>
						<img src={imgHelpGraphicSlider} alt='Slider explanation graphic' />
					</div>
				</div>
			</Cluster>
		);

	}

	return null;

}


const mapStateToProps = state => {
	return {
		matter: state.matter,
		token: state.token,
		modal: state.modal,
		offers_primary: state.offers_primary,
		offers_counter: state.offers_counter
	};
}

const mapDispatchToProps = dispatch => {
	return {
		rdxSetModal: (content) => 				dispatch(actions.setModal(content)),
		rdxAcceptOffer: (context,row) => 		dispatch(actions.acceptOffer(context,row)),
		rdxDeclineOffer: (context,row) => 		dispatch(actions.declineOffer(context,row)),
		rdxDeleteMatter: (token,id,code,history) => 	dispatch(actions.deleteMatter(token,id,code,history))
	};
}


export default withRouter(connect(mapStateToProps,mapDispatchToProps)(modal));


// WEBPACK FOOTER //
// ./src/Blocks/Modal.js